export default "__VITE_ASSET__870f3d8e__"